import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { DataService } from '@data/service/data.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private currentUserSubject!: BehaviorSubject<any>;
  public currentUser!: Observable<any>;
  private currentUserAccessSubject!: BehaviorSubject<any>;
  public currentUserAccess!: Observable<any>;
  private currentUserCheckInSubject!: BehaviorSubject<any>;
  public currentUserCheckIn!: Observable<any>;

  constructor(private _router: Router, public dataService: DataService) {
    this.currentUserSubject = new BehaviorSubject<any>(null);
    this.currentUser = this.currentUserSubject.asObservable();
    this.currentUserAccessSubject = new BehaviorSubject<any>(null);
    this.currentUserAccess = this.currentUserAccessSubject.asObservable();
    this.currentUserCheckInSubject = new BehaviorSubject<any>(false);
    this.currentUserCheckIn = this.currentUserCheckInSubject.asObservable();

    const storedProfile = localStorage.getItem('userProfile');
    if (storedProfile) {
      this.currentUserSubject.next(JSON.parse(storedProfile));
    }

    const storedAccess = localStorage.getItem('userAccess');
    if (storedAccess) {
      this.currentUserAccessSubject.next(JSON.parse(storedAccess));
    }
  }

  public get currentUserAccessValue(): any {
    return this.currentUserAccessSubject.value;
  }

  public get currentUserCheckInValue(): any {
    return this.currentUserCheckInSubject.value;
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  public SetCurrentUser(user: any) {
    this.currentUserSubject.next(user);
  }

  public SetCurrentUserAccess(user: any) {
    this.currentUserAccessSubject.next(user);
  }

  public SetUserCheckIn(checkIn: any) {
    this.currentUserCheckInSubject.next(checkIn);
  }

  login() {
    if (window.location.host == "localhost:4200") {

      window.localStorage.clear();

      // for (var key in creds['credentials']) {
      //   if (creds['credentials'].hasOwnProperty(key)) {
      //     window.localStorage.setItem(key, creds['credentials'][key])
      //   }
      // }
    }

    // this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(window.localStorage['userProfile']));
    // this.currentUser = this.currentUserSubject.asObservable();
    // this.currentUserAccessSubject = new BehaviorSubject<any>(JSON.parse(window.localStorage['userAccessPermission']).records);
    // this.currentUserAccess = this.currentUserAccessSubject.asObservable();
  }

  logout() {
    this.clearAuthStorage();
    this.currentUserSubject.next(null);
    this.currentUserAccessSubject.next(null);
    this.currentUserCheckInSubject.next(false);
    this._router.navigate(['/login'], { replaceUrl: true });
  }

  isLogin() {
    const token = localStorage.getItem('userSecret');
    const profile = localStorage.getItem('userProfile');

    if (!token || !profile) {
      this.clearAuthStorage();
      return false;
    }

    return true;
  }

  private clearAuthStorage(): void {
    localStorage.removeItem('userSecret');
    localStorage.removeItem('userProfile');
    localStorage.removeItem('userClaim');
    localStorage.removeItem('userRoles');
    localStorage.removeItem('userAccess');
    localStorage.removeItem('isLoggin');
    localStorage.removeItem('system');
    localStorage.removeItem('currentUser');
  }
}
